module.exports = __webpack_public_path__ + "img/link-outdated.ec1d20f1.jpg";